import type { AfterCellChanged } from 'common/types/scalarSpreadsheet';
import { RANGE_SENSITIVITY_SPREADSHEET_SENSITIVITY_PCT } from 'pages/ValuationsAllocation/common/constants/rangeSensitivity/sheetAliases';
import { getNumberValue } from 'utilities';

/**
 * When the sensitivity % input (A1) is valid, mirror the value into the hidden
 * last-valid row (A2) so cross-sheet bound formulas keep using the last valid percentage.
 * Invalid values still update A1 for display/validation but leave A2 unchanged.
 */
const afterCellChangedPct: AfterCellChanged = (changes, cells) => {
  const changeList: Array<{ cell: (typeof changes)[number]['cell']; value: (typeof changes)[number]['value'] }> = [];

  changes.forEach(change => {
    const { cell, value } = change;

    if (
      cell.alias === RANGE_SENSITIVITY_SPREADSHEET_SENSITIVITY_PCT &&
      cell.columnLegend === 'A'
    ) {
      changeList.push(change);

      const raw = getNumberValue(value as number | string | null | undefined);
      if (raw > 0) {
        const lastValidKey = `A${cell.rowNumber + 1}`;
        const lastValidCell = cells[lastValidKey];
        if (lastValidCell) {
          changeList.push({ cell: lastValidCell, value: raw });
        }
      }
      return;
    }

    changeList.push(change);
  });

  return changeList;
};

export default afterCellChangedPct;
